import {ObjectChangeLog} from "../../../model/object-change-log";
import {otsBaseApi} from "../../ots-api";
import {EntityIdentifier} from "../../../model/entity";

export type ObjectChangeLogEntityIdentifier = EntityIdentifier & {tenantCode?: string};

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['ObjectChangeLogs', 'ObjectObjectChangeLogs']})

export const objectChangeLogApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getObjectChangeLogsByObject: builder.query<ObjectChangeLog[], ObjectChangeLogEntityIdentifier>(
      {
        query: (eo) => ({
          url: '/object-change-logs/entity',
          method: 'GET',
          params: {id: eo.id, type: eo.type},
          headers: eo.tenantCode ? {'X-Tenant-Id': eo.tenantCode} : undefined,
        }),
        providesTags: (result) => {
          if (result) {
            return [
              ...result.map(
                ({id}) => ({type: 'ObjectChangeLogs', id: id} as const)
              ),
              ...result.map(
                ({objectId}) => ({type: 'ObjectObjectChangeLogs', id: objectId} as const)
              ),
              {type: 'ObjectChangeLogs', id: 'LIST'},
            ];
          } else {
            return [{type: 'ObjectChangeLogs', id: 'LIST'}];
          }
        },
      }
    ),
    getObjectChangeLog: builder.query<ObjectChangeLog, string>({
      query: (id) => ({
        url: `/object-change-logs/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{type: 'ObjectObjectChangeLogs', id: id}],
    }),
  }),
})

export const {
  useGetObjectChangeLogsByObjectQuery,
  useGetObjectChangeLogQuery,
} = objectChangeLogApi;
